import type { ShopifyProduct } from '@/hooks/queries/use-shopify-products-query';

export function getProductDisplayPriceAmount(product: ShopifyProduct): number | null {
  const variantPrices = product.variants
    .map((variant) => variant.priceInCents)
    .filter((priceInCents) => Number.isFinite(priceInCents));

  if (variantPrices.length > 0) {
    return Math.min(...variantPrices) / 100;
  }

  const priceRangeAmount = Number.parseFloat(product.priceRange.min.amount);
  return Number.isFinite(priceRangeAmount) ? priceRangeAmount : null;
}
